<template>
  <div class="contenedor-svg-redes-clusters">
    <div class="tooltip-general">
      <div class="tooltip-contenido">
        <p class="tooltip-cabeza"></p>
      </div>
    </div>
    <svg class="vis-redes-clusters">
      <g class="grupo-contenedor-redes"></g>
    </svg>
    <div class="paginacion">
      <button
        class="anterior"
        @click="paginaAnterior"
        :class="{ disponible: esta_botton_anterior_disponible }"
      ></button>
      <span>{{ `${pagina_actual + 1} / ${numero_paginas + 1}` }}</span>
      <button
        class="siguiente"
        @click="paginaSiguiente"
        :class="{ disponible: esta_botton_siguiente_disponible }"
      ></button>
    </div>
  </div>
</template>
<script>
// CEC-21-2352-BGAA e cluster_id
import * as d3 from "d3";
import { mapGetters, mapState } from "vuex";

export default {
  name: "RedesClusters",
  data() {
    return {
      data_lista: false,
      clusters_por_pagina: 25,
      clusters_renglones: 4,
      clusters_columnas: 5,
      pagina_actual: 0,
      radio: 3.5,
      factor_distancia_links: 0.00013,
      numero_paginas: 0,
      duracion_simulacion: 4500,
      ancho_tooltip: 200,
      scroll_visualizacion: true,
      esta_botton_anterior_disponible: false,
      esta_botton_siguiente_disponible: true,
      diccionario_seguridad_social: {
        Missing: "sin dato",
        desconoce: "No sabe",
        IMSS: "IMSS",
        INSABI: "INSABI",
        ISSSTE: "ISSSTE",
        Otro: "Otro",
        "No Sabe": "No sabe",
        "No sabe": "No sabe",
        Desconoce: "No sabe",
        undefined: "Sin dato",
        null: "Sin dato",
        otrol: "Otro",
      },
      opciones_seguro_social: ["No sabe", "Sin dato", "IMSS", "INSABI", "ISSSTE", "Otro"],
      opciones_sexos: ["Hombre cis", "Mujer cis", "Hombre trans", "Mujer trans"],
      opciones_edades: ["16-24", "25-34", "35-44", "45-54", "55-64", "65 y más", "Sin dato"],
    };
  },
  props: {
    datos: {
      type: Object,
    },
    opciones_antirretroviral: Array,
    cortes_carga_viral: Array,
    cortes_conteo_linfocitos: Array,
    cortes_distancia_genetica: Array,
    cortes_numero_pacientes: Array,
  },
  mounted() {
    this.diccionario_colores_resistencia = {};
    for (let i = 0; i < this.opciones_antirretroviral.length; i++) {
      this.diccionario_colores_resistencia[this.opciones_antirretroviral[i].valor] =
        this.opciones_antirretroviral[i].color;
    }

    this.configurandoDimensionesRedesClusters();
    this.alto = 400;
    this.svg = d3.select("svg.vis-redes-clusters").attr("width", this.ancho);
    this.definiendoLayoutClusters();
    this.grupo_clusters = this.svg.select("g.grupo-contenedor-redes");
    this.tooltip = d3.select(".contenedor-svg-redes-clusters div.tooltip-general");
    this.tooltip.style("visibility", "hidden");
    this.formatoTemporal = d3.timeParse("%Y-%m-%d");
    window.onscroll = () => {
      if (Object.keys(this.datos).includes("links") && this.scroll_visualizacion) {
        if (window.scrollY >= this.alto - 500) {
          this.scroll_visualizacion = false;
          this.obteniendoClusters();
          this.filtrandoClusters();
          this.ordenandoClusters();
          this.creandoClusters();
          if (document.querySelector("div.contenedor-svg-redes-clusters")) {
            setTimeout(() => {
              this.reescalandoPantalla();
            }, 500);
          }
          window.addEventListener("resize", this.reescalandoPantalla);
        }
      }
    };
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.reescalandoPantalla);
  },
  watch: {
    datos(nuevoval) {
      if (nuevoval) {
        this.data_lista = true;
        // Se filtran solo nos nodos que tienen enlaces - cluster
        this.datos.nodes = this.datos.nodes.filter((d) => d.cluster_id != 0);
        this.datos.nodes.forEach((d) => {
          d.seguridad_social = this.diccionario_seguridad_social[d.seguridad_social];
        });
      }
    },
    orden_clusters(nv) {
      this.pagina_actual = 0;
      this.ordenandoClusters();
      this.creandoClusters();
    },
    check_antirretroviral(nv) {
      if (this.clusters) {
        this.filtrandoClusters();
        this.ordenandoClusters();
        this.creandoClusters();
      }
    },
    check_carga_viral(nv) {
      if (this.clusters) {
        this.filtrandoClusters();
        this.ordenandoClusters();
        this.creandoClusters();
      }
    },
    check_conteo_linfocitos(nv) {
      if (this.clusters) {
        this.filtrandoClusters();
        this.ordenandoClusters();
        this.creandoClusters();
      }
    },
    check_distancia_genetica(nv) {
      if (this.clusters) {
        this.filtrandoClusters();
        this.ordenandoClusters();
        this.creandoClusters();
      }
    },
    check_pacientes_cluster() {
      if (this.clusters) {
        this.filtrandoClusters();
        this.ordenandoClusters();
        this.creandoClusters();
      }
    },
    check_genero() {
      if (this.clusters) {
        this.filtrandoClusters();
        this.ordenandoClusters();
        this.creandoClusters();
      }
    },
    check_edad() {
      if (this.clusters) {
        this.filtrandoClusters();
        this.ordenandoClusters();
        this.creandoClusters();
      }
    },
    check_ss() {
      if (this.clusters) {
        this.filtrandoClusters();
        this.ordenandoClusters();
        this.creandoClusters();
      }
    },
    vistaSimplificada(nv) {
      if (nv == false && !this.scroll_visualizacion) {
        this.reescalandoPantalla();
      }
    },
  },
  computed: {
    ...mapState([
      "orden_clusters",
      "check_antirretroviral",
      "check_carga_viral",
      "check_conteo_linfocitos",
      "check_distancia_genetica",
      "check_pacientes_cluster",
      "check_genero",
      "check_edad",
      "check_ss",
    ]),
    vistaSimplificada() {
      return this.$store.getters.tieneVistaSimplificada;
    },
    ...mapGetters(["actualModalClusterEstatus"]),
  },

  methods: {
    configurandoDimensionesRedesClusters() {
      if (window.innerWidth < 769) {
        this.ancho = !this.vistaSimplificada
          ? document.querySelector("div.contenedor-svg-redes-clusters").clientWidth
          : 300;
      } else {
        this.ancho = !this.vistaSimplificada
          ? document.querySelector("div.tablero-cuerpo")?.clientWidth -
            document.querySelector("div.item-check-resistencia").clientWidth -
            document.querySelector("div.item-graficas").clientWidth -
            30
          : 300;
      }
    },
    definiendoLayoutClusters() {
      if (window.innerWidth < 768) {
        this.clusters_renglones = 4;
        this.clusters_columnas = 2;
        this.clusters_por_pagina = this.clusters_renglones * this.clusters_columnas;
        this.alto = 350;
      } else {
        this.clusters_renglones = 4;
        this.clusters_columnas = 5;
        this.clusters_por_pagina = this.clusters_renglones * this.clusters_columnas;
        this.alto = 330; //window.innerHeight < 800 ? document.querySelector("div.item-check-resistencia").clientHeight - 100 : 500;
      }
      this.svg = d3.select("svg.vis-redes-clusters").attr("height", this.alto);
    },
    reescalandoPantalla() {
      if (!this.vistaSimplificada) {
        this.configurandoDimensionesRedesClusters();
        this.svg.attr("height", this.alto).attr("width", this.ancho);
        this.definiendoLayoutClusters();
        this.numero_paginas = parseInt(this.clusters.length / this.clusters_por_pagina, 10);
        this.creandoClusters();
        this.clusters_vista.forEach((d) => {
          d.simulacion.restart();
        });
      }
    },
    paginaSiguiente() {
      if (this.pagina_actual < this.numero_paginas) {
        this.esta_botton_anterior_disponible = true;
        this.esta_botton_siguiente_disponible = true;
        this.pagina_actual += 1;
        this.creandoClusters();
      }
      if (this.pagina_actual == this.numero_paginas) {
        this.esta_botton_siguiente_disponible = false;
      }
    },
    paginaAnterior() {
      if (this.pagina_actual > 0) {
        this.esta_botton_anterior_disponible = true;
        this.esta_botton_siguiente_disponible = true;
        this.pagina_actual -= 1;
        this.creandoClusters();
      }
      if (this.pagina_actual == 0) {
        this.esta_botton_anterior_disponible = false;
      }
    },
    obteniendoClusters() {
      this.clusters_totales = Array.from(
        d3.rollup(
          this.datos.nodes,
          (d) => ({
            num_nodos: d.length,
            num_links: this.datos.links.filter((dd) => dd.cluster_id == d[0].cluster_id).length,
            links: this.datos.links.filter((dd) => dd.cluster_id == d[0].cluster_id),
            nodes: d,
            id: d[0].cluster_id,
            densidad:
              (2 * this.datos.links.filter((dd) => dd.cluster_id == d[0].cluster_id).length) /
              (d.length * (d.length - 1)),
            fecha_max: d3.max(d.map((dd) => this.formatoTemporal(dd.fecha_toma))),
          }),
          (d) => d.cluster_id
        )
      ).map((d) => d[1]);
      this.$store.commit(
        "cambiaNumeroNodosClusters",
        d3.sum(this.clusters_totales.map((d) => d.num_nodos))
      );
      this.clusters = this.clusters_totales;
      this.numero_paginas = parseInt(this.clusters.length / this.clusters_por_pagina, 10);
    },
    filtrandoClusters() {
      this.pagina_actual = 0;
      this.opciones_re_activos = this.opciones_antirretroviral.filter((d) =>
        this.check_antirretroviral.includes(d.id)
      );
      this.cortes_cv_activos = this.cortes_carga_viral.filter((d) =>
        this.check_carga_viral.includes(d.id)
      );
      this.cortes_cl_activos = this.cortes_conteo_linfocitos.filter((d) =>
        this.check_conteo_linfocitos.includes(d.id)
      );
      this.cortes_dg_activos = this.cortes_distancia_genetica.filter((d) =>
        this.check_distancia_genetica.includes(d.id)
      );
      this.cortes_np_activos = this.cortes_numero_pacientes.filter((d) =>
        this.check_pacientes_cluster.includes(d.id)
      );

      this.clusters = this.clusters_totales
        .filter((d) => {
          // filtro de resistencia
          return d.nodes
            .map((dd) => {
              var a = this.opciones_re_activos
                .map((intervalos) => {
                  return dd.resistencia == intervalos.valor;
                })
                .includes(true);
              dd.filtro_re = a;
              return a;
            })
            .includes(true);
        })
        .filter((d) => {
          // filtro de carga viral
          return d.nodes
            .map((dd) => {
              var a = this.cortes_cv_activos
                .map((intervalos) => {
                  return dd.cv >= intervalos.rango[0] && dd.cv < intervalos.rango[1];
                })
                .includes(true);
              dd.filtro_cv = a;
              return a;
            })
            .includes(true);
        })
        .filter((d) => {
          // filtro de conteo de linfocitos
          return d.nodes
            .map((dd) => {
              var a = this.cortes_cl_activos
                .map((intervalos) => {
                  return dd.cd4_a >= intervalos.rango[0] && dd.cd4_a < intervalos.rango[1];
                })
                .includes(true);
              dd.filtro_cl = a;
              return a;
            })
            .includes(true);
        })
        .filter((d) => {
          // filtro de distancia genética
          return d.links
            .map((dd) => {
              var a = this.cortes_dg_activos
                .map((intervalos) => {
                  return dd.distancia >= intervalos.rango[0] && dd.distancia < intervalos.rango[1];
                })
                .includes(true);
              dd.filtro_dg = a;
              return a;
            })
            .includes(true);
        })
        .filter((d) => {
          // filtro de número de nodos
          return this.cortes_np_activos
            .map(
              (intervalos) =>
                d.num_nodos >= intervalos.rango[0] && d.num_nodos < intervalos.rango[1]
            )
            .includes(true);
        })
        .filter((d) => {
          // filtro genero
          return d.nodes.map((dd) => this.check_genero.includes(dd.sexo)).includes(true);
        })
        .filter((d) => {
          // filtro edad
          return d.nodes.map((dd) => this.check_edad.includes(dd.edad_rango)).includes(true);
        })
        .filter((d) => {
          // filtro ss (Seguro social)
          return d.nodes.map((dd) => this.check_ss.includes(dd.seguridad_social)).includes(true);
        });

      this.$store.commit("cambiaNumeroClusters", this.clusters.length.toLocaleString("en"));
      this.actualizacionesDataEdad();
      this.actualizacionDataSS();
      this.actualizacionDataSexo();
      this.numero_paginas = parseInt(this.clusters.length / this.clusters_por_pagina, 10);
    },
    actualizacionDataSS() {
      // Variable para obtener listado de seguridades sociales de nodos mostrados
      this.seguridades_sociales = [];
      this.clusters.map((d) =>
        d.nodes.map((dd) => {
          this.seguridades_sociales = this.seguridades_sociales.concat(dd.seguridad_social);
        })
      );
      this.numero_de_seguros_sociales = this.opciones_seguro_social.map((d) => {
        return {
          nombre: d,
          cantidad: this.seguridades_sociales.filter((dd) => dd == d).length,
        };
      });
      this.$store.commit("cambiaDataClustersSeguroSocial", this.numero_de_seguros_sociales);
    },
    actualizacionDataSexo() {
      this.sexos = [];
      this.clusters.map((d) =>
        d.nodes.map((dd) => {
          this.sexos = this.sexos.concat(dd.sexo);
        })
      );
      this.numero_por_sexo = this.opciones_sexos.map((d) => {
        return {
          nombre: d,
          cantidad: this.sexos.filter((dd) => dd == d).length,
        };
      });
      this.$store.commit("cambiaDataClustersSexo", this.numero_por_sexo);
    },
    actualizacionesDataEdad() {
      // Variable para obtener listado de edades de los nodos mostrados
      this.edades = [];
      this.clusters.map((d) =>
        d.nodes.map((dd) => {
          this.edades = this.edades.concat(dd.edad_rango);
        })
      );
      this.numero_de_edades = this.opciones_edades.map((d) => {
        return {
          nombre: d,
          cantidad: this.edades.filter((dd) => dd == d).length,
        };
      });
      this.$store.commit("cambiaDataClustersEdad", this.numero_de_edades);
    },
    calculandoGruposDeEdad(edades) {
      this.grupos_de_edad = {};
    },
    calculandoGruposSeguridaSocial(edades) {
      this.grupos_de_edad = {};
    },
    ordenandoClusters() {
      if (this.orden_clusters == "numero-nodos") {
        this.clusters = this.clusters.sort((a, b) => d3.descending(a.num_nodos, b.num_nodos));
      } else if (this.orden_clusters == "numero-enlaces") {
        this.clusters = this.clusters.sort((a, b) => d3.descending(a.num_links, b.num_links));
      } else if (this.orden_clusters == "paciente-mas-reciente") {
        this.clusters = this.clusters.sort((a, b) => d3.descending(a.fecha_max, b.fecha_max));
      } else if (this.orden_clusters == "densidad-cluster") {
        this.clusters = this.clusters
          .sort((a, b) => d3.descending(a.num_nodos, b.num_nodos))
          .sort((a, b) => d3.descending(a.densidad, b.densidad));
      }
    },
    creandoClusters() {
      let tiempo_fin_simulacion = Date.now() + this.duracion_simulacion;
      this.clusters_vista = this.clusters.slice(
        this.pagina_actual * this.clusters_por_pagina,
        (this.pagina_actual + 1) * this.clusters_por_pagina
      );
      this.grupo_clusters.selectAll("g.clusters").remove();
      this.clusters_vista.forEach((d, i) => {
        d.indice = i;
        d.simulacion = new d3.forceSimulation(d.nodes.slice())
          .force(
            "link",
            d3
              .forceLink()
              .id((dd) => dd.id)
              .links(d.links.slice())
              .distance(this.ancho * this.alto * this.factor_distancia_links)
              .strength(0.1)
          )
          .force(
            "x",
            d3
              .forceX()
              .x(0)
              .strength((d) => Math.pow(this.clusters_columnas / this.ancho, 2) * 1600)
          )
          .force(
            "y",
            d3
              .forceY()
              .y(0)
              .strength((d) => Math.pow(this.clusters_renglones / this.alto, 2) * 1600)
          )
          .force("charge", d3.forceManyBody().strength(-10))
          .force("collision", d3.forceCollide().radius(this.radio + 1))
          .on("tick", () => this.actualizandoPosiciones(tiempo_fin_simulacion, d.simulacion, i));
      });
      this.grupos_clusters = this.grupo_clusters
        .selectAll("clusters")
        .data(this.clusters_vista)
        .enter()
        .append("g")
        .attr("class", "clusters")
        .attr(
          "transform",
          (d, i) =>
            `translate(${
              (0.5 * this.ancho) / this.clusters_columnas +
              ((i % this.clusters_columnas) * this.ancho) / this.clusters_columnas
            }, ${
              (0.5 * this.alto) / this.clusters_renglones +
              (this.alto * parseInt(i / this.clusters_columnas, 10)) / this.clusters_renglones
            })`
        )
        .on("mouseover", (evento, datum) => {
          d3.select(evento.target.parentNode)
            .selectAll("circle")
            .attr("r", this.radio * 1.5);
          this.overCluster(evento, datum);
        })
        .on("mouseout", (evento) => {
          d3.select(evento.target.parentNode).selectAll("circle").attr("r", this.radio);
          this.outCluster();
        })
        .on("mousemove", (evento) => {
          let contenido_tooltip = this.tooltip.select("div.tooltip-contenido");

          this.tooltip
            .style(
              "left",
              `${evento.layerX - parseInt(contenido_tooltip.style("width"), 10) * 0.5}px`
            )
            .style(
              "top",
              `${evento.layerY - 1 * parseInt(contenido_tooltip.style("height"), 10) - 10}px`
            );
        })
        .on("click", (evento, datum) => {
          this.openModal({
            densidad: datum.densidad,
            fecha_max: datum.fecha_max,
            id: datum.id,
            indice: datum.indice,
            links: [...datum.links],
            nodes: [...datum.nodes],
            num_links: datum.num_links,
            num_nodos: datum.num_nodos,
          });
          datum.simulacion.stop();
        });
      this.grupos_clusters
        .append("rect")
        .attr("x", -this.ancho / (2 * this.clusters_columnas))
        .attr("y", -this.alto / (2 * this.clusters_renglones))
        .attr("height", this.alto / this.clusters_renglones)
        .attr("width", this.ancho / this.clusters_columnas)
        .style("fill", "rgba(255,255,255,0)");
      this.enlaces = this.grupos_clusters
        .selectAll("ln")
        .data((d) => d.links)
        .enter()
        .append("line")
        .style("stroke", "#000")
        .style("stroke-opacity", ".3")
        .style("stroke-width", "1px");

      this.nodos = this.grupos_clusters
        .selectAll("crcl")
        .data((d) => d.nodes)
        .enter()
        .append("circle")
        .style("stroke", "#fff")
        .style("fill", (d) => this.diccionario_colores_resistencia[d.resistencia])
        .style("stroke-width", ".5px")
        .attr("r", this.radio);
    },
    overCluster(evento, datum) {
      this.tooltip.style("visibility", "visible");
      this.tooltip
        .style("left", `${evento.layerX - this.ancho_tooltip * 0.5}px`)
        //.style('top', `${(this.alto / 20)+ this.alto * parseInt(datum.indice / 8, 10) / 5}px`)
        .style("height", `${30}px`);
      let contenido_tooltip = this.tooltip
        .select("div.tooltip-contenido")
        .style("background", "rgba(0, 0, 0,.8)")
        .style("border-radius", "5px")
        .style("padding", "0 3px 0 10px");

      contenido_tooltip
        .select("p.tooltip-cabeza")
        .text("Conglomerado " + datum.num_nodos + " personas")
        .style("margin", "0")
        .style("padding", "0");
      this.tooltip
        .style("left", `${evento.layerX - parseInt(contenido_tooltip.style("width"), 10) * 0.5}px`)
        .style("height", `${contenido_tooltip.style("height")}`)
        .style(
          "top",
          `${evento.layerY - 1 * parseInt(contenido_tooltip.style("height"), 10) - 10}px`
        );
    },
    outCluster() {
      this.tooltip.style("visibility", "hidden");
    },
    openModal(datum) {
      this.$store.commit("cambiarModalDatos", [datum, this.diccionario_colores_resistencia]);
    },
    actualizandoPosiciones(tiempo, sim, i) {
      if (Date.now() < tiempo) {
        this.enlaces
          .attr("x1", (d) => d.source.x)
          .attr("y1", (d) => d.source.y)
          .attr("x2", (d) => d.target.x)
          .attr("y2", (d) => d.target.y);
        this.nodos.attr("transform", (d) => `translate(${d.x},${d.y})`);
      } else {
        sim.stop();
        if (d3.select(this.nodos._groups[0][0]).attr("transform") == null) {
          sim.restart();
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
div.contenedor-svg-redes-clusters {
  width: 100%;
  position: relative;
  div.tooltip-general {
    position: relative;
    display: inline-block;
    div.tooltip-contenido {
      color: #fff;
      line-height: 20px;
      display: inline-block;
    }
  }
  svg.vis-redes-clusters {
    margin-top: 15px;
  }
}
div.paginacion {
  margin: auto;
  text-align: center;
  width: 300px;
  span {
    font-size: 12px;
    @media (max-width: map-get($media-queries-limit, "mobile")) {
      color: rgb(104, 104, 104);
    }
    margin: 0 5px;
  }
  button {
    background: none;
    margin: 0px;
    width: 10px;
    height: 10px;
    padding: 5px;
    border-bottom: 1px solid rgb(184, 184, 184);
    border-radius: 0;
    &.disponible {
      border-bottom: 1px solid #000;
    }
    &.anterior {
      margin-right: 10px;
      border-left: 1px solid rgb(184, 184, 184);
      transform: rotate(45deg);
      &.disponible {
        border-left: 1px solid #000;
      }
    }
    &.siguiente {
      margin-left: 10px;
      border-right: 1px solid rgb(184, 184, 184);
      transform: rotate(-45deg);
      &.disponible {
        border-right: 1px solid #000;
      }
    }
  }
}
</style>
